





import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'

/**
 * @status stable
 * @published $next
 * @changelog $next Published.
 */
@Component({})
export default class SheetExampleInterim extends Vue {
}
